module.exports = __webpack_public_path__ + "static/media/tasksMenuIcon.bb145449.svg";